// extracted by mini-css-extract-plugin
export default {"header-3":"adc__header-3--x7HiY","header-2":"adc__header-2--mcGQg","header-1":"adc__header-1--w8YJb","similar-properties-container":"adc__similar-properties-container--CdLAG"};